import { Badge, CloseButton, Tooltip } from '@mantine/core';
import { IconUserExclamation } from '@tabler/icons-react';
import { trpc } from '../lib/trpc';

/**
 * Compact header pill shown while impersonating — the vendor-panel
 * counterpart to `ImpersonationBanner` (still used as-is by the SuperAdmin
 * central panel). Clicking the close icon calls the same
 * `auth.endImpersonation` mutation the full banner's button does.
 */
export function ImpersonationPill() {
  const endImpersonation = trpc.auth.endImpersonation.useMutation({
    onSuccess: () => {
      window.location.href = '/vendor/team';
    },
  });

  return (
    <Tooltip label="Session is read-write under the target user's permissions">
      <Badge
        color="orange"
        variant="light"
        size="lg"
        leftSection={<IconUserExclamation size={12} />}
        rightSection={
          <CloseButton
            size="xs"
            color="orange"
            aria-label="Exit impersonation"
            disabled={endImpersonation.isPending}
            onClick={() => endImpersonation.mutate()}
          />
        }
      >
        Impersonating
      </Badge>
    </Tooltip>
  );
}
